export const autoLeapBlendedColorsArray = ['#10C09D', '#0FB292', '#0DA586', '#0C977B', '#0A8970', '#097B65', '#076E59', '#06604E', '#045243', '#034438', '#01372C', '#00231c', '#002921', '#00110f'];

export const appointmentRequestTrialStatus = Object.freeze({
  trial: 'trial',
  expired: 'expired',
  full: 'full',
});

export const manualPaymentStatus = Object.freeze({
  nextPart: 'nextPart',
  manualOrder: 'manualOrder',
  partsTech: 'partsTech',
  tireHub: 'tireHub',
  tireConnect: 'tireConnect',
  repairLink: 'repairLink',
  speedDial: 'speedDial',
});

export const printReportLabel = Object.freeze({
  sales: 'sales',
  dailyPayment: 'daily-payment',
  partsTech: 'partsTech',
  taxSummaryItems: 'breakdown-tax-report',
  itemSoldReport: 'items-enhance-item-sold-detail', // drill down report
  mainItemSoldReport: 'items-enhance-item-sold', // main report
  royaltyReport: 'royalty',
  tireStorage: 'tireStorage',
});

export const userCenterConstants = Object.freeze({
  intercomLink: 'https://help.myautoleap.com/',
  releaseLink: 'https://autoleap.com/release/',
  autoLeapBlog: 'https://autoleap.com/blog',
  facebookLink: 'https://www.facebook.com/groups/autoleapcommunity',
  referralLink: 'https://autoleap.com/referrals/?utm_source=in-app&utm_medium=user-center&utm_campaign=referrals',
  trainingVideos: 'https://help.myautoleap.com/en/collections/4013849-training-videos',
});

export const printStickerConstants = Object.freeze({
  default: 'default',
  custom: 'custom',
});

export const supplierOrderTypeStatus = Object.freeze({
  purchaseOrder: 'Purchase Order',
  roPartsOrder: 'RO parts order',
});

export const serviceStatus = Object.freeze({
  estimate: {
    class: 'bg-service-orange',
  },
  pending: {
    class: 'bg-service-orange',
  },
  declined: {
    class: 'bg-red-service',
  },
  archived: {
    class: 'bg-red-service',
  },
  deferred: {
    class: 'bg-red-service',
  },
  deferredLocked: {
    class: 'bg-red-service',
  },
  invoice: {
    class: 'bg-primary',
  },
  approved: {
    class: 'bg-primary',
  },
});

export const activityTypeSupplierOrder = Object.freeze({
  itemDelivered: 'Item Delivered',
  payment: 'Payment',
  coreReturn: 'Core Return',
  itemReturn: 'Item Return',
});

export const activityTypeSupplierOrderSublet = Object.freeze({
  completed: 'Completed',
  paid: 'Paid',
});

export const globalPayPaymentStatusCode = Object.freeze({
  approved: 'Approved',
  approved_avs_mismatch: 'Approved',
  'approved_csc mismatch': 'Approved',
  approved_csc_mismatch: 'Approved',
  approved_avs_csc_mismatch: 'Approved',
  approved_token_creation_failed: 'Approved',
  partially_approved: 'Partially approved',
  partially_approved_avs_mismatch: 'Partially approved',
  partially_approved_csc_mismatch: 'Partially approved',
  partially_approved_avs_csc_mismatch: 'Partially approved',
  captured: 'Captured',
  closed: 'Closed',
  declined: 'Declined',
  voided: 'Void',
  credit: 'Credit',
});

export const chargeAccountLimitTooltip = `<div style="width: 300px;" class='font-12 font-secondary-800 text-white p-1'>
<div class="p-1">
  RO total exceeds customer's available credit limit.
</div>
<div class="p-1">
  You won't be able to finalize this RO as AR.
</div>
<div class="p-1">
  Click on the amount to manage AR.
</div>
</div>`;

export const MockDate = [
  {
    name: 'Body',
    id: 1,
    type: 'standard',
    isCustom: false,
    subItems: [
      {
        id: '1231',
        name: 'Bushings',
        subItems: [
          {
            id: '12312',
            name: 'Brake Pedal Bushing',
          },
          {
            id: '12313',
            name: 'Brake Pedal Bushing 2',
          },
          {
            id: '1234',
            name: 'Brake Pedal Bushing 3',
          },
        ],
      },
      {
        name: 'Floor',
        id: '1235',
        subItems: [
          {
            id: '1236',
            name: 'Accelerator / Brake / Clutch Pedal Pad Set',
          },
          {
            id: '12317',
            name: 'Accelerator / Brake / Clutch Pedal Pad Set 2',
          },
          {
            id: '12318',
            name: 'Accelerator / Brake / Clutch Pedal Pad Set 3',
          },
        ],
      },
      {
        name: 'Body Penals',
        id: '12319',
        subItems: [
          {
            id: '123110',
            name: 'Accelerator / Brake / Clutch Pedal Pad Set',
          },
          {
            id: '123111',
            name: 'Accelerator / Brake / Clutch Pedal Pad Set 2',
          },
          {
            id: '123112',
            name: 'Accelerator / Brake / Clutch Pedal Pad Set 3',
          },
        ],
      },
      {
        name: 'Control Module',
        id: '123113',
        subItems: [
          {
            id: '123114',

            name: 'Accelerator / Brake / Clutch Pedal Pad Set',
          },
          {
            id: '123115',

            name: 'Accelerator / Brake / Clutch Pedal Pad Set 2',
          },
          {
            id: '123116',

            name: 'Accelerator / Brake / Clutch Pedal Pad Set 3',
          },
        ],
      },
      {
        name: 'Switches',
        id: '123117',

        subItems: [
          {
            id: '123118',

            name: 'Accelerator / Brake / Clutch Pedal Pad Set',
          },
          {
            id: '123119',

            name: 'Accelerator / Brake / Clutch Pedal Pad Set 2',
          },
          {
            id: '123120',

            name: 'Accelerator / Brake / Clutch Pedal Pad Set 3',
          },
        ],
      },
    ],
  },
  {
    id: 2,
    name: 'Body 2',
    type: 'standard',
    isCustom: false,
    subItems: [
      {
        id: '123132',
        name: 'Bushings',
        subItems: [
          {
            id: '1231vv2',
            name: 'Brake Pedal Bushing',
          },
          {
            id: '12aa313',
            name: 'Brake Pedal Bushing 2',
          },
          {
            id: '123dd4',
            name: 'Brake Pedal Bushing 3',
          },
        ],
      },
      {
        name: 'Floor',
        id: '123523',
        subItems: [
          {
            id: '1das236',
            name: 'Accelerator / Brake / Clutch Pedal Pad Set',
          },
          {
            id: '12asd317',
            name: 'Accelerator / Brake / Clutch Pedal Pad Set 2',
          },
          {
            id: '12asd318',
            name: 'Accelerator / Brake / Clutch Pedal Pad Set 3',
          },
        ],
      },
      {
        name: 'Body Penals',
        id: '12319234',
        subItems: [
          {
            id: '1asd23110',
            name: 'Accelerator / Brake / Clutch Pedal Pad Set',
          },
          {
            id: '123df111',
            name: 'Accelerator / Brake / Clutch Pedal Pad Set 2',
          },
          {
            id: '1gh23112',
            name: 'Accelerator / Brake / Clutch Pedal Pad Set 3',
          },
        ],
      },
      {
        name: 'Control Module',
        id: '12311343',
        subItems: [
          {
            id: '123fd114',

            name: 'Accelerator / Brake / Clutch Pedal Pad Set',
          },
          {
            id: '123sdf115',

            name: 'Accelerator / Brake / Clutch Pedal Pad Set 2',
          },
          {
            id: '123ew116',

            name: 'Accelerator / Brake / Clutch Pedal Pad Set 3',
          },
        ],
      },
      {
        name: 'Switches',
        id: '1232431dfg17',

        subItems: [
          {
            id: '123sdf118',

            name: 'Accelerator / Brake / Clutch Pedal Pad Set',
          },
          {
            id: '123sdf119',

            name: 'Accelerator / Brake / Clutch Pedal Pad Set 2',
          },
          {
            id: '12g3120',

            name: 'Accelerator / Brake / Clutch Pedal Pad Set 3',
          },
        ],
      },
    ],
  },
];

export const concernsTypeList = [
  { label: 'Customer Concern', key: 'concerns.customerConcern', value: 'customerConcern', icon: 'assets/img/customer-concern-dvi2.svg' },
  { label: 'Safety Issue', key: 'concerns.safetyIssue', value: 'safetyIssue', icon: 'assets/img/concern-type-safety.svg' },
  { label: 'Monitor for Time or Mileage', key: 'concerns.monitorTimeMileage', value: 'monitorTimeMileage', icon: 'assets/img/concern-type-monitor.svg' },
  { label: 'While We Are Here...', key: 'concerns.whileHere', value: 'whileHere', icon: 'assets/img/concern-type-here.svg' },
  { label: 'Suggested Maintenance Items', key: 'concerns.maintainanceItem', value: 'maintainanceItem', icon: 'assets/img/concern-type-maintenance.svg' },
  { label: 'Cosmetic & Optional Items', key: 'concerns.cosmeticItem', value: 'cosmeticItem', icon: 'assets/img/concern-type-cosmetic.svg' },
];

export const WarrantyReportCSV = [
  { isChecked: true, value: 'itemType', name: 'Item Type', isShowSortIcon: true, class: 'title' },
  { isChecked: true, value: 'itemName', name: 'Item Name', isShowSortIcon: false, class: 'category' },
  { isChecked: true, value: 'itemNumber', name: 'Item #', isShowSortIcon: false, class: 'count' },
  { isChecked: true, value: 'quantity', name: 'Qty', isShowSortIcon: false, class: 'workedHours' },
  { isChecked: true, value: 'cost', name: 'Cost', isShowSortIcon: false, class: 'billedHours' },
  { isChecked: true, value: 'warrantyNumber', name: 'Warranty #', isShowSortIcon: false, class: 'partsMargin' },
  { isChecked: true, value: 'roNumber', name: 'Repair Order #', isShowSortIcon: false, class: 'laborMargin' },
  { isChecked: true, value: 'warrantyType', name: 'Warranty Type', isShowSortIcon: false, class: 'tiresMargin' },
  { isChecked: true, value: 'oWarrantyNumber', name: 'Orignal Warranty #', isShowSortIcon: false, class: 'tiresStorageMargin' },
  { isChecked: true, value: 'oRoNumber', name: 'Orignal RO #', isShowSortIcon: false, class: 'otherMargin' },
  { isChecked: true, value: 'oFinalizationDate', name: 'Orignal Finalization Date', isShowSortIcon: false, class: 'date' },
  { isChecked: true, value: 'oItemNumber', name: 'Orignal Part #', isShowSortIcon: false, class: 'avgPrice' },
];
